import { render } from "./TaskEdit.vue?vue&type=template&id=bf1c21dc&scoped=true"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"

import "./TaskEdit.vue?vue&type=style&index=0&id=bf1c21dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf1c21dc"

export default script